import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import UbiquitiHostContext from '@totem/components/ubiquiti/hosts/List/ubiquitiHostContainerContext';
import UbiquitiHostCard from '@totem/components/ubiquiti/hosts/UbiquitiHostCard';

import { groupDevicesByHost } from '../../utilities';

import './ubiquitiHosts.css';

const UbiquitiHostsCards = () => {
  const { hostData } = useContext(UbiquitiHostContext);

  const getGroups = () => {
    if (hostData !== null && hostData.devices !== null) {
      return groupDevicesByHost(hostData.devices);
    }
    return [];
  };

  return (
    <div styleName="host-grid">
      {getGroups().map((group) => (
        <Link
          key={group.host.id}
          to={`/dashboard/ubiquiti/hosts/${group.host.id}`}
          state={{ group }}
          style={{ display: 'block' }}
        >
          <UbiquitiHostCard group={group} />
        </Link>
      ))}
    </div>
  );
};

export default UbiquitiHostsCards;
